<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th v-for="column in columns"
          @click="sortBy(column.key)"
          :class="{active: sortKey == column.key}">
          {{column.name}}
          <span class="arrow"
            v-if="column.sort"
            :class="sortOrders[column.key] > 0 ? 'asc' : 'dsc'">
          </span>
        </th>
        <th>Fjern</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="
        entry in data
        | filterBy filterKey
        | orderBy sortKey sortOrders[sortKey]">
        <td v-for="column in columns">
          {{entry[column.key]}}
        </td>
        <td>
          <div class="button-small pointer-hover" @click="onClick($index)">Fjern</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TableData',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    filterKey: String
  },
  data () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    isFunction (test) {
      return typeof test === 'function'
    },
    onClick (index) {
      this.$emit('remove', index)
    }
  }
}
</script>

<style lang="scss" scoped>

th {
  background-color: #222;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
}

th, td {
  min-width: 120px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid;
}
</style>


// WEBPACK FOOTER //
// TableData.vue?54a7cc66